// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from './id.js'
import {PayloadType, unionListToPayloadType, unionToPayloadType} from './payload-type.js'
import {TransientInteraction} from './transient-interaction.js'

export class Op {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): Op {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsOp(bb: flatbuffers.ByteBuffer, obj?: Op): Op {
    return (obj || new Op()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsOp(bb: flatbuffers.ByteBuffer, obj?: Op): Op {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new Op()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  id(obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Id()).__init(this.bb_pos + offset, this.bb!) : null
  }

  clientTime(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : BigInt('0')
  }

  serverTime(): bigint | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : null
  }

  audioTime(): bigint | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : null
  }

  payloadType(): PayloadType {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : PayloadType.NONE
  }

  payload<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 14)
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null
  }

  transientInteraction(obj?: TransientInteraction): TransientInteraction | null {
    const offset = this.bb!.__offset(this.bb_pos, 16)
    return offset
      ? (obj || new TransientInteraction()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null
  }

  static startOp(builder: flatbuffers.Builder) {
    builder.startObject(7)
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, idOffset, 0)
  }

  static addClientTime(builder: flatbuffers.Builder, clientTime: bigint) {
    builder.addFieldInt64(1, clientTime, BigInt('0'))
  }

  static addServerTime(builder: flatbuffers.Builder, serverTime: bigint) {
    builder.addFieldInt64(2, serverTime, null)
  }

  static addAudioTime(builder: flatbuffers.Builder, audioTime: bigint) {
    builder.addFieldInt64(3, audioTime, null)
  }

  static addPayloadType(builder: flatbuffers.Builder, payloadType: PayloadType) {
    builder.addFieldInt8(4, payloadType, PayloadType.NONE)
  }

  static addPayload(builder: flatbuffers.Builder, payloadOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, payloadOffset, 0)
  }

  static addTransientInteraction(builder: flatbuffers.Builder, transientInteractionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, transientInteractionOffset, 0)
  }

  static endOp(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // id
    builder.requiredField(offset, 14) // payload
    return offset
  }
}
